const TOKEN_KEY = '2021sftdtdk'

export function getToken(){
	let info = JSON.parse(localStorage.getItem(TOKEN_KEY));
	let now = Date.now();
	// 计算过期时间，预留了 60*5=300秒 = 5分钟的机动时间
	// 后端返回的expires_in 为秒数，需要转换为毫秒
	if(info){
		let expire_time = parseInt(info.token_created_at) + ( (parseInt(info.expires_in) - 300) * 1000)
		if(now > expire_time){
			removeToken()
			return null;
		}else {
			return info.access_token
		}
	}else {
		return null
	}
}

export function setToken(data) {
	data = {
		token_created_at: Date.now(),
		...data
	}
	return localStorage.setItem(TOKEN_KEY,JSON.stringify(data))
}

export function removeToken() {
	return localStorage.removeItem(TOKEN_KEY)
}

